export default {
  // Language options
  lang: {
    zh: '简体中文',
    en: 'English',
    de: 'Deutsch',
  },

  // Navigation
  nav: {
    home: 'Home',
    marketArea: 'Market Area',
    productCenter: 'Products',
    serviceSupport: 'Service & Support',
    news: 'News',
    contactUs: 'Contact Us',
  },

  // Footer
  footer: {
    followUs: 'Follow & Contact Us',
    email: 'Email: info-am@melonbean.com',
    address: 'Address: No.5 Dongli South Road, Torch Development Zone, Zhongshan, Guangdong',
    home: 'Home',
    marketArea: 'Market Area',
    productCenter: 'Products',
    serviceSupport: 'Service & Support',
    contactUs: 'Contact Us',
    market: {
      chemical: 'Chemical',
      spaceflight: 'Aerospace',
      electron: 'Electronics',
      AI: 'AI',
      transportation: 'Transportation',
      newEnergy: 'New Energy',
      architecture: 'Architecture',
      homeAppliances: 'Home Appliances',
    },
    product: {
      heatConduction: 'Thermal Management',
      heatInsulation: 'Heat Insulation & Nano Board',
      thermalInsulation: 'Thermal Insulation',
      fireproof: 'Fireproof / High-Temp Coating',
      insulation: 'Insulation',
      electricHeating: 'Electric Heating',
      dielectric: 'Electrical Insulation',
      electricConduction: 'EMI/EMC',
    },
    contact: {
      contactInfo: 'Contact Info',
      companyAddress: 'Company Address',
      joinUs: 'Join Us',
    },
    copyright: '© 2025 Melonbean Innovative Materials Co., Ltd. All Rights Reserved',
  },

  // Home
  home: {
    bannerTitle: 'Making innovative materials for a better life',
    bannerSubtitle: 'Create a better life with materials',
    companyTitle: 'Company Profile',
    companyIntro: 'MELONBEAN (Germany) Innovative Materials Co., Ltd. – founded in January 2019 – maintains a global footprint with R&D headquarters in Germany and a dedicated center in China. The company focuses on developing and applying innovative materials for thermal and electrical management, offering tailored solutions across insulation, heat retention, thermal storage, Thermal Management, electric heating, fire protection, electrical insulation, conductivity, and antistatic applications.',
    companyIntro2:'What sets MELONBEAN apart is its vertically integrated R&D approach, giving it end-to-end control over the entire value chain – from raw materials right through to final product applications. This deep, hands-on knowledge of material behavior allows us to respond precisely to customer needs and adapt seamlessly to real-world use cases. At the same time, MELONBEAN actively shares its R&D progress with numerous partners across Europe and the Americas, fostering collaborative innovation.',
    culture: 'Corporate Culture',
    mission: 'Mission',
    missionInfo: 'Making innovative materials for a better life',
    vision: 'Vision',
    visionInfo: 'To be the preferred partner for thermal and electrical management materials',
    value: 'Values',
    valueInfo: 'Grounded in Reality',
    productTitle: 'Products',
    viewAll: 'View All →',
    moreInfo: 'More Info',
    solutionTitle: 'Solutions',
    newsTitle: 'News Center',
    news: {
      article1: "0.028 thermal conductivity insulation coating adopted by major domestic clients.",
      article2: "Fire-resistant insulation coating for aircraft fuel tank protection.",
      article3: "Thermal PCMs mass-applied in servers & AI devices.",
      article4: 'High-temperature thermal insulation material for turbocharger of diesel engine',
      article5: '3W & 5W thermal pads, mass used for servers.',
    },
    products: {
      fireproof: {
        title: 'Fireproof Coating',
        content: 'High-temperature resistant coating based on organic-inorganic hybrid silicone resin, with excellent high-temperature resistance. Can withstand up to 2000°C for short periods and 650°C for long-term use.',
      },
      thermalInsulation: {
        title: 'Thermal Insulation Coating',
        content: 'Applied by spraying onto various substrates including metal, inorganic, and plastic materials. Thermal conductivity as low as 0.025 W/m·K, with silica aerogel as the primary insulating filler.',
      },
      dielectricCoating: {
        title: 'Dielectric Coating',
        content: 'High-temperature dielectric coating with long-term resistance up to 300°C. Can withstand thousands of degrees of flame briefly while maintaining excellent electrical insulation. Suitable for new energy vehicles, power, and electric heating applications.',
      },
      heatConduction: {
        title: 'Thermal Management Material',
        content: 'Thermal interface materials used on chips and other heat-generating components to fill gaps and rapidly conduct heat away. Includes thermal pads, gels, phase-change sheets, greases, tapes, and graphite sheets.',
      },
      nanoBoard: {
        title: 'Microporous Insulation',
        content: 'Nano insulation boards effectively block all heat transfer paths (conduction, convection, radiation). Thermal conductivity lower than air at low temperatures and lower than aerogel at high temperatures.',
      },
      electricConduction: {
        title: 'Conductive Material',
        content: 'Graphene-based conductive coatings offer excellent electrical conductivity and resistive heating. Silver-paste-based coatings provide superior electrical conduction. Both types operate at up to 300°C continuously.',
      },
      electricHeating: {
        title: 'Electric Heating',
        content: 'Uses conductive coatings to generate heat. Compatible with various substrates including metal, glass, and plastic. Applied by spraying or screen-printing, then cured at high temperatures.',
      },
      heatInsulation: {
        title: 'Heat Insulation',
        content: 'Aerogel insulation film formed through a special process into a thin film, providing excellent thermal insulation to protect heat-sensitive components in consumer electronics, extending product lifespan.',
      },
      dielectric: {
        title: 'Insulation',
        content: 'High-temperature dielectric coating with long-term resistance up to 300°C and can withstand thousands of degrees of flame briefly while maintaining excellent electrical insulation properties.',
      },
    },
    solutions: {
      spaceflight: 'Aerospace',
      chemical: 'Chemical',
      electron: 'Electronics',
      transportation: 'Transportation',
      newEnergy: 'New Energy',
      AI: 'AI',
      architecture: 'Architecture',
      homeAppliances: 'Home Appliances',
    },
  },

  // Market Area
  marketArea: {
    bannerTitle: 'Market Area',
    title: 'Market Area',
    more: 'More',
    exploreMore: 'Explore More Applications',
    breadcrumbMarketArea: 'Market Area',
    characteristics: {
      heatConduction: 'Thermal Management',
      heatInsulation: 'Heat Insulation',
      dielectric: 'Electrical Insulation',
      electricConduction: 'EMI/EMC',
      thermalInsulation: 'Thermal Insulation',
      fireproof: 'Fireproof'
    },
    list: {
      chemical: { 
        title: 'Chemical', 
        content: 'The petroleum and petrochemical industry is the main energy source for countries around the world. Statistics show that petroleum and petrochemicals use 25% of all thermal insulation materials annually. Large amounts of pipelines and thermal equipment require thermal insulation and cooling insulation. Currently, the status and technical level of thermal insulation and cooling insulation vary greatly, and technical level directly relates to capacity construction, cost, and environmental protection. Melonbean has many cases in thermal insulation and fire protection, providing superior materials to better serve the petroleum and petrochemical industry.'
      },
      spaceflight: { 
        title: 'Aerospace', 
        content: 'In recent years, aerospace has developed rapidly, and aerospace-related materials have also developed rapidly, while placing more requirements on materials. Spacecraft thermal management systems extensively use thermal insulation materials, thermal conductive materials, coatings, and thermal conductive fillers, all utilizing material thermal-physical properties to control spacecraft temperature fields. In the future, as human exploration of outer space becomes more frequent, materials face stricter requirements such as high-reliability materials, lightweight materials, multifunctional composite materials, extreme temperature-resistant materials, and intelligent thermal control materials. Melonbean has deep research and accumulation in thermal insulation and fire protection, providing special material options.'
      },
      electron: { 
        title: 'Electronics', 
        content: 'In the era of electronic product explosion, with diversified and complex functions and demands, coupled with AI computing power, electronic product designers/users pursue smaller, thinner, lighter, faster, and more reliable electronic products, whether smartphones, laptops, wearable devices, IoT devices, including current humanoid robots. Electronic products data processing and storage capacity is rapidly increasing, requiring higher comprehensive thermal management including Thermal Management, heat dissipation, thermal uniformity, and heat insulation to meet device requirements. Melonbean can customize different products to meet different needs and improve electronic product performance.'
      },
      AI: { 
        title: 'AI', 
        content: 'With the advent of the AI era, various large models, large computations, and large storage are emerging. Chip computations are increasing with higher frequency requirements, but product and design space is becoming smaller, causing power density and thermal flow density of electronic components in AI devices to increase dramatically. Thermal management challenges are growing, driving development of various thermal management products like graphene, ultra-thin VC, and liquid cooling. Melonbean can provide thermal management materials with different performance characteristics (thermal interface materials, thermal insulation materials, conductive, insulating) to meet AI industry needs.'
      },
      transportation: { 
        title: 'Transportation', 
        content: 'Traditional transportation is being replaced by intelligent transportation, such as Japans Shinkansen and Chinas CRH, with more cities building subway systems. Peoples requirements for transportation are gradually increasing. Research and development of new transportation materials aims to improve vehicle performance, safety, and environmental friendliness. These materials include lightweight alloys, carbon fiber composites, high-strength steel, and nanotechnology-modified materials. Using these materials, vehicles can achieve weight reduction, lower energy consumption, reduced emissions, and extended service life. Additionally, application of these materials promotes transportation design innovation, improving performance and aesthetics.'
      },
      newEnergy: { 
        title: 'New Energy', 
        content: 'Under the premise of global warming, countries have begun vigorously developing new energy-related industries (electric vehicles, fuel cell vehicles, energy storage, wind energy, photovoltaics). These new industries greatly promote society and personal life, strengthening peoples determination to win the fight against CO2. These industries demand for new materials is increasingly strong. Electric vehicle battery packs and energy storage system battery packs have more complex and demanding thermal management requirements, with higher requirements for fire protection, thermal insulation, and electrical insulation, placing more performance and reliability requirements on materials. Melonbean actively participates in the new energy field with many positive and beneficial attempts, accumulating rich industry experience.'
      },
      architecture: { 
        title: 'Architecture', 
        content: 'In the continuous promotion of building energy conservation, construction and decoration companies and real estate developers have raised high requirements for thermal insulation and fire resistance of building insulation materials, striving to significantly reduce energy consumption and thereby reduce environmental pollution and greenhouse effects. Using good insulation materials in industry helps reduce product energy consumption and production costs, providing great social benefits. Building industry development trends include exterior wall insulation, lightweight development, green development, functional diversification, and requirements for transparent insulation materials. Melonbeans thermal insulation and fire protection materials can meet industry needs and assist global environmental protection.'
      },
      homeAppliances: { 
        title: 'Home Appliances', 
        content: 'As global living standards improve, people have increasingly professional and refined requirements for household appliances, with more functional demands such as air fryers, ovens, dishwashers, and many products requiring internet connectivity like smart TVs and refrigerators. Therefore, requirements for various functional materials are increasing, which is Melonbeans area of expertise.'
      },
    },
    pages: {
      chemical: {
        title: 'Chemical',
        content: 'The petroleum and petrochemical industry is the main energy source for countries around the world. Statistics show that petroleum and petrochemicals use 25% of all thermal insulation materials annually. Large amounts of pipelines and thermal equipment require thermal insulation and cooling insulation. Currently, the status and technical level of thermal insulation and cooling insulation vary greatly, and technical level directly relates to capacity construction, cost, and environmental protection. Melonbean has many cases in thermal insulation and fire protection, providing superior materials to better serve the petroleum and petrochemical industry.'
      },
      spaceflight: {
        title: 'Aerospace',
        content: 'In recent years, aerospace has developed rapidly, and aerospace-related materials have also developed rapidly, while placing more requirements on materials. Spacecraft thermal management systems extensively use thermal insulation materials, thermal conductive materials, coatings, and thermal conductive fillers, all utilizing material thermal-physical properties to control spacecraft temperature fields. In the future, as human exploration of outer space becomes more frequent, materials face stricter requirements such as high-reliability materials, lightweight materials, multifunctional composite materials, extreme temperature-resistant materials, and intelligent thermal control materials. Melonbean has deep research and accumulation in thermal insulation and fire protection, providing special material options.'
      },
      electron: {
        title: 'Electronics',
        content: 'In the era of electronic product explosion, with diversified and complex functions and demands, coupled with AI computing power, electronic product designers/users pursue smaller, thinner, lighter, faster, and more reliable electronic products, whether smartphones, laptops, wearable devices, IoT devices, including current humanoid robots. Electronic products data processing and storage capacity is rapidly increasing, requiring higher comprehensive thermal management including Thermal Management, heat dissipation, thermal uniformity, and heat insulation to meet device requirements. Melonbean can customize different products to meet different needs and improve electronic product performance.'
      },
      AI: {
        title: 'AI',
        content: 'With the advent of the AI era, various large models, large computations, and large storage are emerging. Chip computations are increasing with higher frequency requirements, but product and design space is becoming smaller, causing power density and thermal flow density of electronic components in AI devices to increase dramatically. Thermal management challenges are growing, driving development of various thermal management products like graphene, ultra-thin VC, and liquid cooling. Melonbean can provide thermal management materials with different performance characteristics (thermal interface materials, thermal insulation materials, conductive, insulating) to meet AI industry needs.'
      },
      transportation: {
        title: 'Transportation',
        content: 'Traditional transportation is being replaced by intelligent transportation, such as Japans Shinkansen and Chinas CRH, with more cities building subway systems. Peoples requirements for transportation are gradually increasing. Research and development of new transportation materials aims to improve vehicle performance, safety, and environmental friendliness. These materials include lightweight alloys, carbon fiber composites, high-strength steel, and nanotechnology-modified materials. Using these materials, vehicles can achieve weight reduction, lower energy consumption, reduced emissions, and extended service life. Additionally, application of these materials promotes transportation design innovation, improving performance and aesthetics.'
      },
      newEnergy: {
        title: 'New Energy',
        content: 'Under the premise of global warming, countries have begun vigorously developing new energy-related industries (electric vehicles, fuel cell vehicles, energy storage, wind energy, photovoltaics). These new industries greatly promote society and personal life, strengthening peoples determination to win the fight against CO2. These industries demand for new materials is increasingly strong. Electric vehicle battery packs and energy storage system battery packs have more complex and demanding thermal management requirements, with higher requirements for fire protection, thermal insulation, and electrical insulation, placing more performance and reliability requirements on materials. Melonbean actively participates in the new energy field with many positive and beneficial attempts, accumulating rich industry experience.'
      },
      architecture: {
        title: 'Architecture',
        content: 'In the continuous promotion of building energy conservation, construction and decoration companies and real estate developers have raised high requirements for thermal insulation and fire resistance of building insulation materials, striving to significantly reduce energy consumption and thereby reduce environmental pollution and greenhouse effects. Using good insulation materials in industry helps reduce product energy consumption and production costs, providing great social benefits. Building industry development trends include exterior wall insulation, lightweight development, green development, functional diversification, and requirements for transparent insulation materials. Melonbeans thermal insulation and fire protection materials can meet industry needs and assist global environmental protection.'
      },
      homeAppliances: {
        title: 'Home Appliances',
        content: 'As global living standards improve, people have increasingly professional and refined requirements for household appliances, with more functional demands such as air fryers, ovens, dishwashers, and many products requiring internet connectivity like smart TVs and refrigerators. Therefore, requirements for various functional materials are increasing, which is Melonbeans area of expertise.'
      }
    }
  },

  // Product Center
  productCenter: {
    bannerTitle: 'Product Center',
    title: 'Product Center',
    more: 'More',
    breadcrumbProductCenter: 'Product Center',
    breadcrumbProductInfo: 'Product Details',
    productDetail: 'Product Details',
    downloadManual: 'Download Product Manual',
    contactForMore: 'For more product information, please contact our sales team and local channels',
    
    // Product List
    products: {
      heatConduction: {
        name: 'Thermal Management Materials',
        content: 'Thermal Interface Materials(TIM) are applied on heat-generating components such as chips to fill gaps and rapidly dissipate heat, reducing operating temperature and ensuring long-term reliability of electronic devices.Our complete product lineup includes thermal pads, thermal gels, phase change material, thermal greases,liquid metal pad,etc. These materials are widely adopted in electronics, telecommunications, automotive and industrial market.'
      },
      nanoBoard: {
        name: 'Microporous Insulation Material',
        content: 'Its unique structure blocks conduction, convection and radiation for superior insulation.Made of nanomaterials with high-temperature reinforcing and insulating components via special forming technology.It has lower thermal conductivity than air at low temperatures and aerogel at high temperatures, with excellent thermal stability and thermal shock resistance.Its insulation performance is several times that of traditional materials, making it ideal for high-temperature insulation.'
      },
      thermalInsulation: {
        name: 'Thermal Insulation Material',
        content: 'Thermal insulation coatings are mainly applied by spraying onto substrates requiring thermal insulation, including metals, inorganics, and plastics, especially suitable for irregular positions. Thermal insulation coatings have thermal conductivity as low as 0.025w/m.k, with silica aerogel as the main thermal insulation filler. For different working temperatures, different hybridization ratios of organic-inorganic hybrid systems are used to meet the temperature range from -40°C to up to 1000°C.'
      },
      fireproof: {
        name: 'Special Coating',
        content: 'High-temperature resistant coatings based on organic-inorganic hybrid silicone resin as the main component, with excellent high-temperature resistance. With appropriate fillers, they can achieve short-term temperature resistance exceeding 2000°C and long-term working temperature of 650°C. Clear coats without pigment fillers can also achieve maximum temperature resistance of 1000°C on stainless steel plates. Some coatings have functions to slow down stainless steel oxidation at high temperatures; others have excellent anti-corrosion properties. Additionally, most of these products have high hardness characteristics, providing excellent wear and scratch resistance.'
      },
      heatInsulation: {
        name: 'Thin Heat Insulation Material',
        content: 'Aerogel insulation film is processed through special techniques to form nano aerogel into thin films, providing excellent insulation performance to solve hot spot issues in limited spaces of consumer electronics and provide insulation protection for heat-sensitive components, improving product lifespan and performance. Nano aerogel insulation films block heat transfer direction through aerogel nano gaps, reducing product surface temperature and eliminating or reducing surface hot spots, improving consumer tactile experience with electronic products. Can be used in combination with other functional materials (such as composite with graphite) to greatly improve material insulation performance.'
      },
      electricHeating: {
        name: 'Electric Heating',
        content: 'Uses conductive coatings for heating. Suitable for different substrates including metals, glass, and plastics. Heating coatings are generally applied to target substrates through spraying or screen printing, achieving film formation and curing through high temperature. Conductive heating coatings can be applied to substrates of different shapes, with heating area and shape flexibly achievable according to requirements.'
      },
      dielectric: {
        name: 'Electrical Insulation Coating',
        content: 'High-temperature dielectric coatings have maximum long-term temperature resistance of 300°C and can withstand thousands of degrees of flame burning for short periods while maintaining excellent electrical insulation performance. Suitable for new energy vehicles, power, electric heating and many other applications requiring electrical insulation in high-temperature environments.'
      },
      electricConduction: {
        name: 'Electrical Conductive Material',
        content: 'Graphene-based conductive coatings have excellent electrical conductivity and conductive heating functions; silver powder-based conductive silver paste has excellent electrical conductivity. Regardless of the type of conductive coating, they can work long-term at 300°C; additionally, coating curing temperature does not exceed 300°C.'
      }
    },

    // Product Detail Tabs
    tabs: {
      hpcm: 'Thermal Phase Change Material-HPCM',
      hgp: 'Thermal Pad-HGP',
      hgpPt: 'Thermal Gel Pad-HGP PT',
      hg: 'Single Component Thermal Gel-HG',
      hf: 'Two Component Thermal Gel-HF',
      hgr: 'Thermal Grease-HGR',
      hi: 'Thermal Insulation Pad-HI',
      htb: 'Thermal Absorbing Pad-HTB',
      hlm: 'Liquid Metal Pad-HLM',
      ahi: 'Aerogel Heat Insulation Film-AHI',
      ahiFoam: 'Aerogel Foam-AHI',
      nanoBoard: 'Microporous Insulation board'
    },

    // Common Component Labels
    common: {
      productFeatures: 'Product Features',
      typicalApplications: 'Typical Applications',
      technicalParameters: 'Technical Parameters',
      testMethod: 'Test Method',
      project: 'Item',
      color: 'Color',
      phaseChangeTemp: 'Phase Change Temperature',
      density: 'Density',
      workingTemp: 'Working Temperature',
      volumeResistivity: 'Volume Resistivity',
      thermalConductivity: 'Thermal Conductivity',
      thermalResistance: 'Thermal Resistance',
      pressure: 'Pressure',
      thickness: 'Thickness',
      hardness: 'Hardness',
      tempRange: 'Temperature Range',
      dielectricConstant: 'Dielectric Constant',
      fireRating: 'Fire Rating',
      component: 'Component',
      annotation: '*Zinc oxide free version',
      thermalResistanceVsPressure: 'Thermal Resistance vs. Pressure',
      visualInspection: 'Visual',
      gray: 'Gray'
    },

    // Product 1 - Thermal Phase Change Material HPCM
    product1: {
      description: 'Thermal phase change material is an interface material made with a special formula and process, offering high thermal conductivity and the ability to change phase at a certain temperature to improve interface wetting performance. Below the phase change temperature the material is solid, making it easy to use and rework. Once the phase change temperature is reached, the material softens and delivers excellent wetting, greatly reducing interface thermal resistance and enhancing heat transfer capability.',
      features: [
        'Thermal conductivity of 2.5~10.0 W/m-K',
        'Ultra-low thermal resistance',
        'Low phase change temperature',
        'Easy die-cutting',
        'Excellent reliability'
      ],
      applications: [
        'CPU & GPU & APU',
        'IGBT Modules',
        'Communication Equipment',
        'Computers',
        'Servers / Data Centers'
      ]
    },

    // Product 3 - Thermal Gel Pad HGP PT
    product3: {
      description: 'Thermal gel pad is a low thermal resistance elastic polymer material with excellent thermal conductivity and self-adhesive properties, effectively filling irregular gaps and providing efficient Thermal Management paths for heat dissipation.',
      features: [
        'Low interface thermal resistance',
        'Excellent surface self-adhesiveness for easy installation',
        'Ultra-low hardness reduces installation stress residue',
        'High compression ratio facilitates gap filling'
      ],
      applications: [
        'Liquid cooling modules/servers',
        'Communication base station equipment',
        'AI equipment',
        'CPU/GPU/APU',
        'Automotive electronics'
      ],
      tableData: [
        {
          project: 'Component',
          test: '-',
          parameter1: 'Silicone',
          parameter2: 'Silicone',
          parameter3: 'Silicone'
        },
        {
          project: 'Color',
          test: 'Visual',
          parameter1: 'White',
          parameter2: 'Gray',
          parameter3: 'Gray'
        },
        {
          project: 'Thermal Conductivity｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '3.5',
          parameter2: '6.0',
          parameter3: '8.0'
        },
        {
          project: 'Thickness｜(mm)',
          test: '-',
          parameter1: '0.5~5.0',
          parameter2: '1.0~5.0',
          parameter3: '1.0~5.0'
        },
        {
          project: 'Density｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '3.2',
          parameter2: '3.3',
          parameter3: '3.4'
        },
        {
          project: 'Hardness｜(shore 00)',
          test: 'ASTM D2240',
          parameter1: '10',
          parameter2: '10',
          parameter3: '10'
        },
        {
          project: 'Temperature Range｜(℃)',
          test: '-',
          parameter1: '-40~150',
          parameter2: '-40~150',
          parameter3: '-40~150'
        },
        {
          project: 'Dielectric Constant｜@1MHZ',
          test: 'ASTM D150',
          parameter1: '7.0',
          parameter2: '8.0',
          parameter3: '10.0'
        },
        {
          project: 'Volume Resistivity｜(Ω-cm)',
          test: 'ASTM D257',
          parameter1: '10¹³',
          parameter2: '10¹³',
          parameter3: '10¹³'
        },
        {
          project: 'Fire Rating',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0'
        }
      ]
    },

    // Product 4 - Single Component Thermal Gel HG
    product4: {
      description: 'Single component thermal gel is a series of high-performance thermal interface materials with low interface thermal resistance, high plasticity, high electrical insulation, and high reliability. It features high-temperature oil separation resistance, non-drying, non-corrosive materials, high and low temperature resistance, and good thixotropic properties, suitable for various components with extremely low stress requirements, ensuring high reliability of various application products.\n\nIt has natural adhesion properties for convenient customer assembly. Customers can also implement automated dispensing according to their own processes to improve production efficiency.',
      features: [
        '2.0~9.0W/m-K thermal conductivity',
        'Ultra-low stress: >40%@10psi',
        'Excellent wettability, effectively reducing interface thermal resistance',
        'High compression ratio, suitable for chip heat transfer at different gaps'
      ],
      applications: [
        'Automotive electronics',
        'Large storage devices',
        'Consumer electronic devices',
        'Communication base station equipment (4G and 5G)',
        'Power modules'
      ],
      tableData: [
        {
          project: 'Component',
          test: '-',
          parameter1: 'Silicone',
          parameter2: 'Silicone',
          parameter3: 'Silicone',
          parameter4: 'Silicone',
          parameter5: 'Silicone'
        },
        {
          project: 'Color',
          test: 'Visual',
          parameter1: 'Blue',
          parameter2: 'Green',
          parameter3: 'Blue',
          parameter4: 'Gray',
          parameter5: 'Pink'
        },
        {
          project: 'Thermal Conductivity｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '2.0',
          parameter2: '3.5',
          parameter3: '5.0',
          parameter4: '7.0',
          parameter5: '9.0'
        },
        {
          project: 'Density｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '2.0',
          parameter2: '3.2',
          parameter3: '3.2',
          parameter4: '3.4',
          parameter5: '3.5'
        },
        {
          project: 'Extrusion Rate｜(g/min)',
          test: '30cc standard tube, 90psi pressure',
          parameter1: '40',
          parameter2: '35',
          parameter3: '35',
          parameter4: '15',
          parameter5: '10'
        },
        {
          project: 'Volatility｜(%)',
          test: 'ASTM E595',
          parameter1: '<0.05',
          parameter2: '<0.05',
          parameter3: '<0.05',
          parameter4: '<0.03',
          parameter5: '<0.03'
        },
        {
          project: 'Temperature Range｜(℃)',
          test: '-',
          parameter1: '-40~150',
          parameter2: '-40~150',
          parameter3: '-40~150',
          parameter4: '-40~150',
          parameter5: '-40~150'
        },
        {
          project: 'Dielectric Constant｜@1MHZ',
          test: 'ASTM D150',
          parameter1: '5.0',
          parameter2: '8.0',
          parameter3: '7.5',
          parameter4: '8.0',
          parameter5: '8.0'
        },
        {
          project: 'Fire Rating',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0',
          parameter4: 'V-0',
          parameter5: 'V-0'
        }
      ]
    },

    // Product 5 - Two Component Thermal Gel HF
    product5: {
      description: 'Two-component thermal gel material is mixed with component A (base) and component B (curing agent) in a certain ratio, and cures into a flexible elastomer at room temperature, featuring excellent thermal conductivity and electrical insulation properties. The cured material maintains good flexibility and resilience, conforming well to various irregular surfaces and providing stable Thermal Management paths. This series can provide various thermal conductivity specifications according to different application requirements.',
      features: [
        '2.0~8.0W/m-K thermal conductivity',
        'Excellent electrical insulation properties',
        'Maintains flexibility and elasticity after curing',
        'Excellent conformability, adapts to irregular surfaces',
        'Good long-term stability'
      ],
      applications: [
        'Automotive electronic ECU',
        'Charging pile modules',
        'Communication base station equipment',
        'Energy storage battery packs',
        'LED lighting heat dissipation'
      ],
      tableData: [
        {
          project: 'Component',
          test: '-',
          parameter1: 'Silicone',
          parameter2: 'Silicone',
          parameter3: 'Silicone',
          parameter4: 'Silicone',
          parameter5: 'Silicone',
          parameter6: 'Silicone'
        },
        {
          project: 'Color',
          test: 'Visual',
          parameter1: 'Blue',
          parameter2: 'Blue',
          parameter3: 'Green',
          parameter4: 'Blue',
          parameter5: 'Gray',
          parameter6: 'Gray'
        },
        {
          project: 'Thermal Conductivity｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '2.0',
          parameter2: '2.0',
          parameter3: '3.5',
          parameter4: '5.0',
          parameter5: '6.0',
          parameter6: '8.0'
        },
        {
          project: 'Density｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '2.2',
          parameter2: '2.0',
          parameter3: '3.2',
          parameter4: '3.2',
          parameter5: '3.3',
          parameter6: '3.4'
        },
        {
          project: 'Hardness｜(Shore A)',
          test: 'ASTM D2240',
          parameter1: '15',
          parameter2: '10',
          parameter3: '25',
          parameter4: '35',
          parameter5: '40',
          parameter6: '45'
        },
        {
          project: 'Tensile Strength｜(MPa)',
          test: 'ASTM D412',
          parameter1: '0.8',
          parameter2: '0.6',
          parameter3: '1.2',
          parameter4: '1.5',
          parameter5: '1.8',
          parameter6: '2.0'
        },
        {
          project: 'Working Time｜(min)',
          test: '25℃',
          parameter1: '45',
          parameter2: '90',
          parameter3: '45',
          parameter4: '40',
          parameter5: '35',
          parameter6: '30'
        },
        {
          project: 'Curing Time｜(h)',
          test: '25℃',
          parameter1: '24',
          parameter2: '24',
          parameter3: '24',
          parameter4: '24',
          parameter5: '24',
          parameter6: '24'
        },
        {
          project: 'Temperature Range｜(℃)',
          test: '-',
          parameter1: '-40~150',
          parameter2: '-40~150',
          parameter3: '-40~150',
          parameter4: '-40~150',
          parameter5: '-40~150',
          parameter6: '-40~150'
        },
        {
          project: 'Dielectric Constant｜@1MHZ',
          test: 'ASTM D150',
          parameter1: '5.0',
          parameter2: '4.5',
          parameter3: '8.0',
          parameter4: '7.5',
          parameter5: '8.0',
          parameter6: '8.5'
        },
        {
          project: 'Fire Rating',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0',
          parameter4: 'V-0',
          parameter5: 'V-0',
          parameter6: 'V-0'
        }
      ]
    },

    // Product 6 - Thermal Grease HGR
    product6: {
      description: 'Thermal grease is a high-performance thermal interface material with excellent thermal conductivity and electrical insulation properties. Made with organic silicone resin as base material and various high thermal conductivity inorganic powders through special processes. Features good thixotropic properties and workability, effectively filling micro gaps between heat-generating components and heat sinks, significantly reducing contact thermal resistance and improving heat dissipation efficiency.',
      features: [
        '2.0~6.0W/m-K thermal conductivity',
        'Excellent thixotropic properties, easy to apply',
        'Superior electrical insulation performance',
        'Good chemical stability',
        'Low interface thickness, efficient heat transfer'
      ],
      applications: [
        'CPU/GPU heat dissipation',
        'Power modules',
        'LED lighting',
        'Automotive electronics',
        'Communication equipment'
      ],
      tableData: [
        {
          project: 'Component',
          test: '-',
          parameter1: 'Silicone',
          parameter2: 'Silicone',
          parameter3: 'Silicone',
          parameter4: 'Silicone'
        },
        {
          project: 'Color',
          test: 'Visual',
          parameter1: 'Yellow',
          parameter2: 'Gray',
          parameter3: 'Gray',
          parameter4: 'Gray'
        },
        {
          project: 'Minimum Interface Thickness',
          test: '-',
          parameter1: '0.030',
          parameter2: '0.045',
          parameter3: '0.045',
          parameter4: '0.04'
        },
        {
          project: 'Density｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '3.1',
          parameter2: '2.9',
          parameter3: '2.9',
          parameter4: '2.9'
        },
        {
          project: 'Viscosity',
          test: 'ASTM D2196',
          parameter1: '<100,000',
          parameter2: '<400,000',
          parameter3: '<250,000',
          parameter4: '<250,000'
        },
        {
          project: 'Temperature Range｜(°C)',
          test: '-',
          parameter1: '-40~150',
          parameter2: '-40~150',
          parameter3: '-40~150',
          parameter4: '-40~150'
        },
        {
          project: 'Volume Resistivity|(Ω.cm)',
          test: 'ASTM D257',
          parameter1: '10¹²',
          parameter2: '10¹¹',
          parameter3: '10¹¹',
          parameter4: '10¹¹'
        },
        {
          project: 'Fire Rating',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0',
          parameter4: 'V-0'
        },
        {
          project: 'Thermal Conductivity｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '2.0',
          parameter2: '3.5',
          parameter3: '5.0',
          parameter4: '6.0'
        }
      ],
      tableDataTwo: [
        {
          project: 'Pressure｜(psi)',
          test: '-',
          parameter1: '50/100',
          parameter2: '50/100',
          parameter3: '50/100',
          parameter4: '50/100'
        },
        {
          project: 'Thermal Resistance｜(℃-cm²/W)',
          test: 'ASTM D5470',
          parameter1: '0.13/0.11',
          parameter2: '0.06/0.05',
          parameter3: '0.05/0.04',
          parameter4: '0.045/0.038'
        }
      ]
    },

    product7: {
      description: 'Thermal insulation pads are a series of high-performance thermal interface materials reinforced with fiberglass cloth and other materials, featuring excellent cut resistance and superior thermal conductivity, widely used in electronics and electrical industries. During use, select different thicknesses of thermal silicone pads for cutting according to the size and gap height of the heating interface, and place them in the gaps between heating interfaces and their components to serve as thermal conductive media.',
      features: [
        'Up to 3.5W/m-K thermal conductivity',
        'Breakdown voltage >6,000Vac',
        'Flexible sheet material, easy to form, can be cut according to customer requirements',
        'Moisture-proof, excellent weather resistance, high reliability, easy to remove',
        'Single-sided adhesive products available (A1)'
      ],
      applications: [
        'OBC onboard chargers',
        'Power amplifiers',
        'Power supplies',
        'Automotive electronics',
        'Power semiconductors'
      ],
      pressureLabel: 'Pressure (psi)',
      thermalResistanceLabel: 'Thermal Resistance (℃-cm²/W)',
      tableData: [
        {
          project: 'Component',
          test: '-',
          parameter1: 'Silicone+Fiberglass',
          parameter2: 'Silicone+Fiberglass',
          parameter3: 'Silicone+Fiberglass',
          parameter4: 'Silicone+PI'
        },
        {
          project: 'Color',
          test: 'Visual',
          parameter1: 'Brown-red',
          parameter2: 'Black',
          parameter3: 'White',
          parameter4: 'Yellow'
        },
        {
          project: 'Thickness｜(mm)',
          test: 'ASTM D374',
          parameter1: '0.23',
          parameter2: '0.23',
          parameter3: '0.25/0.38/0.5',
          parameter4: '0.15'
        },
        {
          project: 'Density｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '2.5',
          parameter2: '2.7',
          parameter3: '1.5',
          parameter4: '2.5'
        },
        {
          project: 'Hardness｜(shore A)',
          test: 'ASTM D2240',
          parameter1: '92',
          parameter2: '80',
          parameter3: '70',
          parameter4: '90'
        },
        {
          project: 'Tensile Strength｜(MPa)',
          test: 'ASTM D412',
          parameter1: '9.0',
          parameter2: '9.0',
          parameter3: '15',
          parameter4: '20'
        },
        {
          project: 'Temperature Range｜(°C)',
          test: '-',
          parameter1: '-60~200',
          parameter2: '-60~200',
          parameter3: '-60~200',
          parameter4: '-60~180'
        },
        {
          project: 'Breakdown Voltage｜(Kv)',
          test: 'ASTM D149',
          parameter1: '>5.5',
          parameter2: '>6.0',
          parameter3: '>4.0',
          parameter4: '>6.0'
        },
        {
          project: 'Fire Rating',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0',
          parameter4: 'V-0'
        },
        {
          project: 'Thermal Conductivity｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '1.6',
          parameter2: '1.8',
          parameter3: '3.5',
          parameter4: '1.3'
        }
      ],
      tableDataTwo: [
        {
          project: 'Pressure｜(psi)',
          test: '-',
          parameter1: '50',
          parameter2: '0.61',
          parameter3: '0.53',
          parameter4: '0.27',
          parameter5: '0.41'
        },
        {
          project: 'Thermal Resistance｜(℃-cm²/W)',
          test: 'ASTM D5470',
          parameter1: '100',
          parameter2: '0.47',
          parameter3: '0.47',
          parameter4: '0.25',
          parameter5: '0.38'
        }
      ]
    },

    // Product 8 - Thermal Absorbing Pad HTB
    product8: {
      description: 'Thermal absorbing pad is a series of thermal interface materials with high thermal performance and certain EMI performance, now widely used in optical modules, communication base stations, etc. During use, select different thicknesses of thermal silicone pads for cutting according to the size and gap height of the heating interface, and place them in the gaps between heating interfaces and their components to achieve good heat transfer function while eliminating certain electromagnetic interference to ensure stable operation of components.',
      features: [
        'Similar to traditional thermal pads, with self-adhesive surface for easy application',
        'Extremely low thermal resistance combined with EMI shielding effect',
        'High reliability',
        'Can partially replace metal shields, reducing cost and easy to operate'
      ],
      applications: [
        'Chassis or related heat dissipation modules',
        'Smart terminals',
        'Communication equipment',
        'Consumer electronics'
      ],
      tableData: [
        {
          project: 'Color',
          test: 'Visual',
          parameter1: 'Black',
          parameter2: 'Black',
          parameter3: 'Black'
        },
        {
          project: 'Thickness｜(mm)',
          test: 'ASTM D374',
          parameter1: '0.5-5.0',
          parameter2: '0.5-5.0',
          parameter3: '0.5-5.0'
        },
        {
          project: 'Thermal Conductivity｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '1.4',
          parameter2: '3',
          parameter3: '6.0'
        },
        {
          project: 'Density｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '4.0',
          parameter2: '3.5',
          parameter3: '4.5'
        },
        {
          project: 'Hardness｜(shore 00)',
          test: 'ASTM D2240',
          parameter1: '92',
          parameter2: '80',
          parameter3: '70'
        },
        {
          project: 'Volume Resistivity｜(Ω.cm)',
          test: 'ASTM D257',
          parameter1: '10¹²',
          parameter2: '10¹²',
          parameter3: '‌10⁸‌'
        },
        {
          project: 'EMI Attenuation',
          test: '(dB/cm)@2 GHz｜(dB/cm) @ 5 GHz',
          parameter1: '8｜15',
          parameter2: '10｜20',
          parameter3: '10｜20'
        },
        {
          project: 'Operating Temperature｜(°C)',
          test: '/',
          parameter1: '-40~180',
          parameter2: '-40~180',
          parameter3: '-40~180'
        },
        {
          project: 'Fire Rating',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0'
        }
      ]
    },

    // Product 9 - Liquid Metal Pad HLM
    product9: {
      description: 'Liquid metal pad is a series of ultra-high performance interface materials used between heating devices and heat sinks. After reaching the phase change temperature of liquid metal, the material automatically softens to fill the gaps between heating devices and heat sinks. It has very low interface thermal resistance and can quickly transfer heat generated by heating devices to the cold side, efficiently reducing heating device temperature and ensuring electronic component performance.',
      features: [
        'Ultra-high thermal conductivity (20~50W/m-k)',
        'High product reliability',
        'No pump-out',
        'No organic volatilization',
        'Environmentally friendly'
      ],
      applications: [
        'Servers',
        'Gaming consoles',
        'GPU/CPU/APU',
        'Communication equipment',
        'Automotive electronics'
      ],
      tableData: [
        {
          project: 'Base Material',
          test: '-',
          parameter1: 'Bismuth alloy',
          parameter2: 'Bismuth alloy',
          parameter3: 'Bismuth alloy'
        },
        {
          project: 'Color',
          test: 'Visual',
          parameter1: 'Bright silver',
          parameter2: 'Bright silver',
          parameter3: 'Bright silver'
        },
        {
          project: 'Thickness｜(mm)',
          test: 'ASTM D374',
          parameter1: '0.07~0.30',
          parameter2: '0.07~0.30',
          parameter3: '0.07~0.30'
        },
        {
          project: 'Phase Change Point｜(°C)',
          test: 'ASTM B774',
          parameter1: '72',
          parameter2: '118',
          parameter3: '60/119'
        },
        {
          project: 'Hardness｜(HB)',
          test: 'ASTME10',
          parameter1: '4.5',
          parameter2: '4.5',
          parameter3: '7.5'
        },
        {
          project: 'Density｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '8.0',
          parameter2: '7.2',
          parameter3: '7.5'
        },
        {
          project: 'Operating Temperature｜(°C)',
          test: '-',
          parameter1: '-50~500',
          parameter2: '-50~500',
          parameter3: '-50~500'
        },
        {
          project: 'Volume Resistivity｜(Ω.m)',
          test: 'ASTM D257',
          parameter1: '10⁻⁸',
          parameter2: '10⁻⁸',
          parameter3: '10⁻⁸'
        },
        {
          project: 'Thermal Conductivity｜(W/m-K)',
          test: 'ASTM E1461',
          parameter1: '30',
          parameter2: '43',
          parameter3: '30'
        }
      ]
    },

    // Product 10 - Aerogel Heat Insulation Film AHI
    product10: {
      description: 'Aerogel heat insulation film is a series of insulation films composed of nano aerogel. Through special processes, nano aerogel is formed into thin films, providing excellent insulation performance to solve hot spot issues in limited spaces of consumer electronics products, insulation protection for weak heat-resistant components, controlling and changing the direction of heat conduction, and improving product lifespan and performance. Nano aerogel insulation film blocks the direction of heat transfer through aerogel nano gaps, thereby reducing product surface temperature, reducing or eliminating hot spots on product surfaces, and improving consumer tactile experience with electronic products.\n\nAerogel insulation film can be made into single-sided adhesive material for easy customer installation and can be used in combination with other functional materials (such as composite with graphite) to greatly improve material insulation performance.',
      features: [
        '0.018~0.023W/m-k low thermal conductivity',
        'Thickness range 0.05-0.4mm',
        'Excellent electrical insulation and easy to die-cut',
        'Can be laminated with other materials'
      ],
      applications: [
        'E-cigarettes',
        'Smartphones',
        'Tablets/Laptops',
        'Smartwatches'
      ],
      tableData: [
        {
          project: 'Material',
          test: '-',
          parameter1: 'Aerogel',
          parameter2: 'Aerogel',
          parameter3: 'Aerogel',
          parameter4: 'Aerogel',
          parameter5: 'Aerogel'
        },
        {
          project: 'Color',
          test: 'Visual',
          parameter1: 'White',
          parameter2: 'White',
          parameter3: 'White',
          parameter4: 'Bright silver',
          parameter5: 'Bright silver'
        },
        {
          project: 'Thermal Conductivity｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '0.018～0.023',
          parameter2: '0.018～0.023',
          parameter3: '0.018～0.023',
          parameter4: '0.018～0.023',
          parameter5: '0.018～0.023'
        },
        {
          project: 'Thickness｜(mm)',
          test: '-',
          parameter1: '0.05',
          parameter2: '0.10',
          parameter3: '0.20',
          parameter4: '0.30',
          parameter5: '0.40'
        },
        {
          project: 'Density｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '0.3',
          parameter2: '0.3',
          parameter3: '0.3',
          parameter4: '0.3',
          parameter5: '0.3'
        },
        {
          project: 'Working Temperature｜(℃)',
          test: '-',
          parameter1: '-40～130',
          parameter2: '-40～130',
          parameter3: '-40～130',
          parameter4: '-40～130',
          parameter5: '-40～130'
        },
        {
          project: 'Dielectric Strength｜(Kv/mm)',
          test: 'ASTM D149',
          parameter1: '>4.0',
          parameter2: '>4.0',
          parameter3: '>4.0',
          parameter4: '>4.0',
          parameter5: '>4.0'
        },
        {
          project: 'Volume Resistivity｜(Ω-cm)',
          test: 'ASTM D257',
          parameter1: '10¹³',
          parameter2: '10¹³',
          parameter3: '10¹³',
          parameter4: '10¹³',
          parameter5: '10¹³'
        }
      ]
    },

    // Product 11 - Aerogel Foam AHI
    product11: {
      description: 'Aerogel foam is a series of insulation foams composed of nano aerogel. Through special supercritical processes, a network of porous nano aerogel structure is formed, providing excellent insulation capability, insulation protection for weak heat-resistant components. The material also has high compressibility, enabling better filling of irregular spaces for improved insulation effects, enhancing product lifespan and user experience.\n\nAerogel insulation foam can be made into single-sided adhesive material for easy customer installation and can also be used in combination with other functional materials (such as graphite composite) to provide compound performance.',
      features: [
        '0.018w/m-k ultra-low thermal conductivity',
        'Thickness 0.5-3.0mm',
        'Excellent compression performance',
        'Excellent electrical insulation',
        'Easy to die-cut'
      ],
      applications: [
        'E-cigarettes',
        'Smartphones',
        'Tablets/Laptops',
        'Smartwatches'
      ],
      tableData: [
        {
          project: 'Material',
          test: '-',
          parameter1: 'Aerogel',
          parameter2: 'Aerogel',
          parameter3: 'Aerogel',
          parameter4: 'Aerogel'
        },
        {
          project: 'Color',
          test: 'Visual',
          parameter1: 'White',
          parameter2: 'White',
          parameter3: 'White',
          parameter4: 'Bright silver'
        },
        {
          project: 'Thermal Conductivity｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '0.018',
          parameter2: '0.07~0.30',
          parameter3: '0.018',
          parameter4: '0.018'
        },
        {
          project: 'Thickness｜(mm)',
          test: '-',
          parameter1: '0.5',
          parameter2: '1.0',
          parameter3: '2.0',
          parameter4: '3.0'
        },
        {
          project: 'Density｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '-0.1',
          parameter2: '-0.1',
          parameter3: '-0.1',
          parameter4: '-0.1'
        },
        {
          project: 'Working Temperature｜(°C)',
          test: '-',
          parameter1: '-60~240',
          parameter2: '-60~240',
          parameter3: '-60~240',
          parameter4: '-60~240'
        },
        {
          project: 'Dielectric Strength｜(Kv/mm)',
          test: 'ASTM D149',
          parameter1: '>3.0',
          parameter2: '>3.0',
          parameter3: '>3.0',
          parameter4: '>3.0'
        },
        {
          project: 'Volume Resistivity｜(Ω-cm)',
          test: 'ASTM D257',
          parameter1: '10¹³',
          parameter2: '10¹³',
          parameter3: '10¹³',
          parameter4: '10¹³'
        }
      ]
    },

    // Product 12 - Nano Board
    product12: {
      description: 'Nano board is a high thermal insulation material. Based on in-depth research of materials, it effectively blocks heat transfer paths (Thermal Management, thermal convection, thermal radiation) to achieve effective and excellent thermal insulation effects. The product is based on aerogel and other nanomaterials, supplemented with high-temperature reinforcement and high-temperature insulation components, processed using special molding techniques.\nNano board material has thermal conductivity lower than air at low temperatures, and lower thermal conductivity than aerogel at high temperatures, while having extremely high thermal stability and superior thermal shock resistance. The insulation performance of aerogel space board is several times that of traditional materials, making it the most ideal high-temperature insulation material on the market.',
      productFeaturesTitle: 'Product Features',
      productFeaturesIntro: 'The thermal conductivity λ of the material is characterized by three heat properties of the material:<br>λtotal = λconduction + λconvection + λradiation',
      productFeatures: [
        'In aerogel and other nanomaterials, nano-scale structures can have extremely small contact points, and nano structures also greatly extend the heat transfer path, thereby reducing the λconduction of the material.',
        'In aerogel and other nanomaterials, nano-scale structures can form effective porosity (up to 90%), and fine nano structures also effectively eliminate air convection (average free path of gas molecules is 70-120nm), thereby reducing heat transfer λconvection.',
        'By adding thermal insulation components to the material structure, the thermal radiation capability of the material can be reduced, minimizing λradiation.'
      ],
      productFeaturesTip: 'Thus overall reducing the thermal conductivity λtotal of the material',
      productDetailTitle: 'Product Details',
      productDetailItems: [
        'Nano board maintains extremely low thermal conductivity at high temperatures, with obvious effect on high-temperature insulation. Third-party test reports show thermal conductivity of only 0.036W/m-k at 800°C, significantly better than supercritical aerogel.',
        'Compared with supercritically dried aerogel felt on the market, nano board insulation performance has obvious advantages (hot plate method).',
        '',
        'Nano board has certain compression performance, ensuring it can absorb battery cell expansion when used between cells, ensuring mechanical performance of cells. Can be customized according to customer requirements.'
      ],
      agingTips: 'Aging test, 85°C&85%RH aging 1000 hours, 125°C high temperature aging 1000 hours, the thermal conductivity, insulation performance, and voltage resistance test of nano board have basically no change, compression performance has slight changes, as follows:',
      bottomTips: '*All materials above were tested with PET thermosetting film',
      tableHeaders: {
        unit: 'Unit',
        testStandard: 'Test Standard',
        agingCondition: 'Aging Condition',
        testTemperature: 'Test Temperature ℃',
        thermalConductivity: 'Thermal Conductivity W/(m-K)',
        insulationTest: 'Insulation Test - Temperature Difference',
        coldSideTemp: 'Insulation Test - Cold Side Temperature',
        voltageTest: 'Voltage Resistance Test (3000V/60S)',
        compressionTest: 'Compression Test',
        strain: 'Strain (%)',
        pressure: 'Pressure'
      },
      tableData: [
        {
          project: 'Operation Temperature｜使用温度',
          test: '°C',
          parameter1: '700',
          parameter2: '950',
          parameter3: '1100',
          parameter4: '1200',
          parameter5: '-'
        },
        {
          project: 'Color｜颜色',
          test: '-',
          parameter1: 'Gray/White',
          parameter2: 'Gray/White',
          parameter3: 'Gray/White',
          parameter4: 'Gray/White',
          parameter5: 'Visual'
        },
        {
          project: 'Thickness｜厚度',
          test: 'mm',
          parameter1: '1.0~5mm',
          parameter2: '1.0~5mm',
          parameter3: '1.0~5mm',
          parameter4: '1.0~5mm',
          parameter5: '-'
        },
        {
          project: 'Density｜密度',
          test: 'kg/m3',
          parameter1: '300',
          parameter2: '300',
          parameter3: '300',
          parameter4: '300',
          parameter5: 'GB/T 17911'
        },
        {
          project: 'Tensile Strength｜抗拉强度',
          test: 'MPa',
          parameter1: '0.15',
          parameter2: '0.15',
          parameter3: '0.15',
          parameter4: '0.15',
          parameter5: 'GB/T 17911'
        },
        {
          project: 'Compression Stress｜压缩性能',
          test: '-',
          parameter1: '15%(1MPa)｜25%(2MPa)',
          parameter2: '15%(1MPa)｜25%(2MPa)',
          parameter3: '15%(1MPa)｜25%(2MPa)',
          parameter4: '15%(1MPa)｜25%(2MPa)',
          parameter5: 'Internal'
        },
        {
          project: 'Electrical Strength｜绝缘强度',
          test: 'kv/mm',
          parameter1: '2.0',
          parameter2: '2.1',
          parameter3: '2.1',
          parameter4: '2.0',
          parameter5: 'GB/T 1408'
        },
        {
          project: 'Surface Resistance｜表面电阻',
          test: 'Ohms',
          parameter1: '>1×10⁹',
          parameter2: '>1×10⁹',
          parameter3: '>1×10⁹',
          parameter4: '>1×10⁹',
          parameter5: 'GB/T 1410'
        },
        {
          project: 'Hi-pot test｜耐压测试',
          test: '3000V｜DC/60S',
          parameter1: 'Pass',
          parameter2: 'Pass',
          parameter3: 'Pass',
          parameter4: 'Pass',
          parameter5: 'IEC 60950'
        },
        {
          project: 'Heat Capacity｜热容',
          test: 'J/g·℃',
          parameter1: '1.09',
          parameter2: '1.1',
          parameter3: '1.13',
          parameter4: '1.15',
          parameter5: 'ISO 11357-4'
        },
        {
          project: 'Thermal Conductivity｜导热系数',
          test: 'W/m-k｜25℃｜200℃｜400℃｜600℃｜800℃',
          parameter1: '-｜0.021｜0.024｜0.026｜0.030｜0.038',
          parameter2: '-｜0.020｜0.022｜0.026｜0.030｜0.036',
          parameter3: '-｜0.019｜0.021｜0.023｜0.026｜0.036',
          parameter4: '-｜0.021｜0.023｜0.026｜0.029｜0.037',
          parameter5: 'GB/T10294'
        },
        {
          project: 'Flammability｜阻燃性',
          test: '-',
          parameter1: 'v-0',
          parameter2: 'v-0',
          parameter3: 'v-0',
          parameter4: 'v-0',
          parameter5: 'UL94'
        },
        {
          project: 'EHS Compliance｜符合性',
          test: '-',
          parameter1: 'Compliant',
          parameter2: 'Compliant',
          parameter3: 'Compliant',
          parameter4: 'Compliant',
          parameter5: '/'
        }
      ],
      tableDataChart: [
        {
          project: 'Pressure (Mpa)',
          test: '0.50',
          parameter1: '1.00',
          parameter2: '1.50',
          parameter3: '2.00',
          parameter4: '2.50'
        }
      ],
      tableData2: [
        {
          project: 'Before aging',
          test: '25',
          parameter1: '0.0253'
        },
        {
          project: '125℃ 500hrs',
          test: '25',
          parameter1: '0.0272'
        },
        {
          project: '125℃ 1000hrs',
          test: '25',
          parameter1: '0.0243'
        },
        {
          project: '85℃&85%RH 500hrs',
          test: '25',
          parameter1: '0.0253'
        },
        {
          project: '85℃&85%RH 1000hrs',
          test: '25',
          parameter1: '0.0260'
        }
      ],
      tableData3: [
        {
          project: 'Before aging',
          test: '85℃&85%RH (500hrs)',
          parameter1: '85℃&85%RH (1000hrs)',
          parameter2: '125℃ (500hrs)',
          parameter3: '125℃ (1000hrs)'
        },
        {
          project: '504.775',
          test: '500',
          parameter1: '503.9',
          parameter2: '505.3',
          parameter3: '503.6'
        }
      ],
      tableData4: [
        {
          project: 'Before aging',
          test: '85℃&85%RH (500hrs)',
          parameter1: '85℃&85%RH (1000hrs)',
          parameter2: '125℃ (500hrs)',
          parameter3: '125℃ (1000hrs)'
        },
        {
          project: '160.5',
          test: '165.3',
          parameter1: '158.3',
          parameter2: '164.7',
          parameter3: '164.5'
        }
      ],
      tableData5: [
        {
          project: 'Before aging',
          test: '85℃&85%RH (500hrs)',
          parameter1: '85℃&85%RH (1000hrs)',
          parameter2: '125℃ (500hrs)',
          parameter3: '125℃ (1000hrs)'
        },
        {
          project: 'With film',
          test: 'With film',
          parameter1: 'With film',
          parameter2: 'With film',
          parameter3: 'With film'
        },
        {
          project: 'Pass',
          test: 'Pass',
          parameter1: 'Pass',
          parameter2: 'Pass',
          parameter3: 'Pass'
        }
      ],
      tableData6: [
        {
          project: 'Pressure',
          test: 'Before aging',
          parameter1: '85℃&85%RH (1000hrs)',
          parameter2: '125℃ (1000hrs)'
        },
        {
          project: '1MPa',
          test: '21.7%',
          parameter1: '18.0%',
          parameter2: '19.2%'
        },
        {
          project: '1.5MPa',
          test: '29.1%',
          parameter1: '24.0%',
          parameter2: '25.5%'
        },
        {
          project: '2MPa',
          test: '34.8%',
          parameter1: '28.5%',
          parameter2: '30.0%'
        }
      ]
    },


  },

  // Service & Support
  serviceSupport: {
    bannerTitle: 'Service & Support',
    title: 'Service & Support',
    learnMore: 'Learn More',
    list: {
      productInfo: 'Product Knowledge',
      development: 'Development Support',
      application: 'Application Support',
      simulation: 'Simulation Support',
    },
    // Product info page
    productInfoPage: {
      pageTitle: 'Product Knowledge',
      breadcrumbService: 'Service & Support',
      breadcrumbProductInfo: 'Product Knowledge',
      tabList: [
        { name: 'Nano Insulation Board Introduction', id: 1 },
        { name: 'Aerogel Introduction', id: 2 },
        { name: 'Thermal Interface Material (TIM) Introduction', id: 3 },
        { name: 'Thermal Insulation Material Introduction', id: 4 }
      ]
    },
    // Product development support page
    developmentPage: {
      pageTitle: 'Product Development Support',
      breadcrumbService: 'Service & Support',
      breadcrumbDevelopment: 'Product Development Support',
      contentTitle: 'Product Development Support',
      contentText: 'Focusing on front-end innovation core, precisely connecting with customers\' new needs and new material application pain points, providing full-process customized R&D collaborative services. From requirement analysis, market trend judgment, new material selection and testing, to formula optimization, structural design, rapid prototyping and performance verification, we are equipped with professional R&D teams for full technical support, breaking technical barriers, helping customers bring new products to market quickly, while optimizing product performance, reducing R&D costs, enhancing core competitiveness and market iteration efficiency, working together with customers to achieve win-win technological innovation and product upgrades.'
    },
    // Simulation support page
    simulationPage: {
      pageTitle: 'Simulation Support',
      breadcrumbService: 'Service & Support',
      breadcrumbSimulation: 'Simulation Support',
      contentTitle: 'Simulation Support',
      contentText: 'Equipped with professional simulation technical teams and advanced simulation tools, providing comprehensive product simulation support services to proactively avoid R&D and application risks. We can conduct multi-dimensional simulation modeling including thermal, mechanical, and fluid dynamics for different product usage scenarios, accurately reproducing product operation status, performance and potential issues under real working conditions. Through simulation analysis to optimize product structural design, material selection and process parameters, significantly reducing physical trial-and-error costs, shortening R&D cycles, while ensuring products meet industry standards in strength, stability, and safety, providing solid technical guarantee for mass production and market launch.'
    },
    // Application support page
    applicationPage: {
      pageTitle: 'Application Support',
      breadcrumbService: 'Service & Support',
      breadcrumbApplication: 'Application Support',
      contentTitle: 'Application Support',
      contentText: 'Drawing on rich industry application experience, we provide comprehensive application solutions for all scenarios, covering multi-format customized product delivery to meet personalized needs across different industries and working conditions. Product formats include large sheets, precision die-cut parts, special-shaped parts, customized assemblies, etc. We can optimize processing techniques according to specific customer application scenarios to ensure product compatibility. Additionally, we provide professional installation guidance, on-site technical commissioning, process optimization recommendations, and post-use maintenance consulting, simplifying customer product implementation processes, solving various technical challenges during application, and ensuring stable product operation.'
    },
    // Product component pages
    servicesProduct1: {
      title: 'Nano Insulation Board Introduction',
      definition: 'Definition',
      definitionContent: 'Nano insulation boards are new inorganic panel materials based on nano microporous thermal insulation principles, made from nano-scale titanium silicate and SiO₂ through special processes to form sub-micron pore structures. Their thermal conductivity is lower than still air, with insulation effects 3-10 times that of traditional materials. They can work stably at 400-1200℃, reducing insulation layer thickness, lowering energy consumption, expanding space, and adapting to multiple scenarios.',
      productIntro: 'Product Introduction',
      productIntroContent: 'Internal micropore diameters are much smaller than air molecule mean free paths, blocking Thermal Management and convection. Inorganic nanoparticles suppress thermal radiation, forming a "triple insulation barrier". 100% inorganic composition, no harmful substances, environmentally safe. Processed through raw material dispersion, compression molding, and custom processing steps.',
      performanceAdvantage: 'Performance Advantages',
      mainProductSystem: 'Main Product System',
      applicationValue: 'Application Value',
      applicationValueContent: 'With "material innovation replacing space consumption", driving industrial equipment to actively reduce consumption, breaking through traditional material protection limits, assisting product miniaturization, and being the core choice for low-carbon and safety upgrades.',
      advantages: [
        {
          title: 'Ultimate Insulation',
          content: ['Thermal conductivity as low as 0.02W/m-k at room temperature;', '0.040W/m-k at 800℃;', 'Energy saving 10-30%;', 'Insulation layer thickness reduced by 50% or more.']
        },
        {
          title: 'Environmental Adaptation',
          content: ['Long-term use at 400-1200℃;', 'Linear shrinkage ≤2% at 1050℃;', 'Available in rigid board, flexible sheet forms;', 'Some products are hydrophobic, Class A fireproof.']
        },
        {
          title: 'Economic & Environmental',
          content: ['Lifespan 5-10 years;', '2-3 times that of traditional materials;', '1-2 year cost recovery;', 'Pure inorganic, recyclable, zero pollution.']
        }
      ],
      tableColumns: {
        productType: 'Product Type',
        keyParams: 'Key Parameters',
        applicableScenario: 'Applicable Scenarios'
      },
      tableData: [
        {
          productType: 'Standard High-Temperature Insulation Board',
          query: '950-1100℃, ≤0.04W/m-k',
          applicableScenario: 'Cement kilns, glass furnaces'
        },
        {
          productType: 'Flexible Insulation Sheet/Felt',
          query: '1000-1200℃, bending radius ≥5cm',
          applicableScenario: 'Industrial pipes, engine covers'
        },
        {
          productType: 'Hydrophobic Insulation Board',
          query: '1050℃, hydrophobicity ≥95%',
          applicableScenario: 'Fuel cells, humid furnaces'
        }
      ]
    },
    servicesProduct2: {
      title: 'Aerogel Product Introduction',
      definition: 'Definition',
      definitionContent: 'Aerogel is a nanomaterial produced by sol-gel method to remove liquid phase while retaining porous network, with gas as dispersion medium. Air content ranges from 90%-99.8%, pore diameter 1-100 nanometers, porosity exceeding 90%, minimum density 0.16mg/cm³, making it one of the lightest solids.',
      productIntro: 'Product Introduction',
      productIntroContent: 'Internal micropore diameters are much smaller than air molecule mean free paths, blocking Thermal Management and convection. Inorganic nanoparticles suppress thermal radiation, forming a "triple insulation barrier". 100% inorganic composition, no harmful substances, environmentally safe. Processed through raw material dispersion, compression molding, and custom processing steps.',
      performanceAdvantage: 'Performance Advantages',
      mainProductSystem: 'Main Product System',
      applicationProspect: 'Application Prospects',
      applicationProspectContent: 'Aerogel leverages multi-dimensional advantages of "light, insulating, strong, adsorptive" properties, gradually expanding from aerospace high-end applications to construction, environmental protection, and daily products. Currently facing challenges of high cost and processing improvement needs, but with process optimization and scale production advancement, it is developing towards "high performance, low cost, green" direction. It will play a core role in energy saving, emission reduction, and high-end manufacturing, becoming a key material transforming multiple industries.',
      advantages: [
        {
          title: 'Ultimate Insulation',
          content: ['Triple heat transfer blocking (suppressing convection, conduction, radiation);', 'Thermal conductivity as low as 0.015W/(m・K) at room temperature, far exceeding traditional insulation materials, stable performance in high and low temperature environments.']
        },
        {
          title: 'Light yet Strong',
          content: ['Extremely low density yet possessing mechanical properties. Carbon aerogel can withstand thousands of times its own weight, fiber-reinforced types combine flexibility, solving traditional aerogel brittleness issues.']
        },
        {
          title: 'Efficient Adsorption & Stability',
          content: ['Specific surface area of 500~3000m²/g, strong adsorption for heavy metals, organic pollutants, gases with regeneration capability;', 'Most types are acid-alkali resistant, high-temperature oxidation resistant, with excellent chemical stability.']
        }
      ],
      tableColumns: {
        productType: 'Type',
        coreCharacteristics: 'Core Characteristics',
        applicationDirection: 'Application Direction'
      },
      tableData: [
        {
          productType: 'Silica Aerogel',
          query: 'Excellent insulation, moderate cost, chemically stable',
          applicableScenario: 'Building/pipeline insulation, appliance insulation, outdoor equipment'
        },
        {
          productType: 'Carbon Aerogel',
          query: 'Good conductivity, high strength, high-temperature resistant',
          applicableScenario: 'Supercapacitors, oil-water separation, high-temperature insulation'
        },
        {
          productType: 'Metal Oxide Aerogel',
          query: 'Extremely temperature resistant (up to 2000℃+), good catalytic activity',
          applicableScenario: 'Aircraft engine insulation, industrial furnaces, catalysis'
        },
        {
          productType: 'Metal Oxide Aerogel',
          query: 'Eco-friendly degradable, flexible, etc.',
          applicableScenario: 'Medical dressings, flexible electronics, complex scenario adaptation'
        }
      ]
    },
    servicesProduct3: {
      title: 'Thermal Interface Material (TIM) Product Introduction',
      definition: 'Definition',
      definitionContent: 'TIM is used to fill gaps between heat-generating components and heat dissipation parts in electronic devices, eliminating insulating air gaps (air thermal conductivity only 0.025W/m-K), reducing contact thermal resistance, building efficient Thermal Management channels, ensuring stable equipment operation and extending lifespan.',
      mainTypes: 'Main Types',
      performanceParameters: 'Performance Parameters',
      selectionPoints: 'Selection Points',
      tableColumns: {
        productType: 'Type',
        typicalForm: 'Typical Form',
        characteristics: 'Characteristics'
      },
      tableData: [
        {
          productType: 'Thermal Grease',
          query: 'Paste fluid (containing thermal particles)',
          applicableScenario: 'Strong filling capacity, low thermal resistance, requires manual application, non-adhesive'
        },
        {
          productType: 'Thermal Pad',
          query: 'Flexible sheet (silicone/rubber substrate)',
          applicableScenario: 'Pre-cuttable, easy installation, cushioning properties, some with adhesive'
        },
        {
          productType: 'Thermal Gel',
          query: 'Semi-fluid gel',
          applicableScenario: 'Automatic gap filling, stress-free, adapts to irregular interfaces'
        },
        {
          productType: 'Thermal Tape',
          query: 'Film with adhesive',
          applicableScenario: 'Combines Thermal Management and bonding, simplifies assembly'
        },
        {
          productType: 'Phase Change Material',
          query: 'Solid at room temperature, melts at 40-80℃',
          applicableScenario: 'Tight contact, stable thermal resistance, no pump-out'
        },
        {
          productType: 'Graphene Pad',
          query: 'Flexible sheet',
          applicableScenario: 'High thermal conductivity >50W, low thermal resistance'
        },
        {
          productType: 'Liquid Metal',
          query: 'Paste/sheet',
          applicableScenario: 'High thermal conductivity, low thermal resistance'
        }
      ],
      performanceParams: [
        { 
          title: 'Thermal Conductivity (K):',
          content: 'Measures Thermal Management ability, unit W/m・K, standard 0.5-15W/m・K, high-end 20-200W/m・K, actual performance affected by pressure and temperature.'
        },
        { 
          title: 'Thermal Resistance (Rθ):',
          content: 'Key thermal transfer indicator, unit ℃-cm²/W, quality products ≤0.1℃-cm²/W under standard pressure, related to fluidity and pressure.'
        },
        { 
          title: 'Temperature Range:',
          content: 'Consumer -40℃ to 150℃, industrial -55℃ to 200℃, must prevent softening, volatilization, cracking.'
        },
        { 
          title: 'Stability:',
          content: 'Most require insulation (volume resistivity ≥10¹²Ω・cm), aging resistance (1000h aging weight loss ≤3%), comply with RoHS, REACH standards.'
        }
      ],
      selectionCriteria: [
        { 
          title: 'Thermal Requirements:',
          content: 'High power select ≥8W/m・K, low power select 1-3W/m・K;'
        },
        { 
          title: 'Installation:',
          content: 'Automation select thermal tape, pre-formed pads; irregular interfaces select gel;'
        },
        { 
          title: 'Environment:',
          content: 'High temperature select heat-resistant type, humid conditions select hydrolysis-resistant type;'
        },
        { 
          title: 'Cost:',
          content: 'Thermal conductivity positively correlates with cost, balance performance and budget.'
        }
      ]
    },
    servicesProduct4: {
      title: 'Thermal Insulation Material Product Introduction',
      intro: 'In construction, industry, transportation and many other fields, thermal insulation materials play a crucial role. They not only effectively save energy but also improve environmental comfort and reduce production costs. The following provides a detailed introduction from basic concepts, classification, common type characteristics, selection points, and development trends of thermal insulation materials.',
      tabList: [
        { name: 'first', label: 'Definition and Core Functions of Thermal Insulation Materials' },
        { name: 'second', label: 'Classification of Thermal Insulation Materials' },
        { name: 'third', label: 'Selection Points for Thermal Insulation Materials' },
        { name: 'fourth', label: 'Development Trends of Thermal Insulation Materials' }
      ],
      tab1: {
        definition: {
          title: 'Definition',
          content: 'Thermal insulation materials, also called heat-resistant materials, refer to materials that can impede heat flow transfer, usually having low thermal conductivity (materials with thermal conductivity less than 0.05W/(m・K) are generally called high-efficiency thermal insulation materials). Through their special structures such as porous or fibrous forms, they reduce heat conduction, convection and radiation, thereby achieving thermal insulation or cooling effects.'
        },
        coreRole: {
          title: 'Core Functions',
          items: [
            {
              title: '1. Energy Saving and Consumption Reduction:',
              content: 'In construction, thermal insulation materials effectively reduce heat exchange between building interiors and exteriors, lowering energy consumption of air conditioning and heating equipment. Statistics show that proper use of thermal insulation materials can reduce building energy consumption by 30%-50%. In industrial production, thermal insulation materials can be used for equipment and pipeline insulation, reducing heat loss, improving energy utilization efficiency, and lowering production costs.'
            },
            {
              title: '2. Improving Environmental Comfort:',
              content: 'For buildings, thermal insulation materials maintain stable indoor temperatures, avoiding overheating in summer and overcooling in winter, enhancing residential and office comfort. In transportation vehicles such as cars, trains, and aircraft, thermal insulation materials reduce the impact of external environmental temperatures on interior spaces, providing passengers with more comfortable travel experiences.'
            },
            {
              title: '3. Equipment Protection and Lifespan Extension:',
              content: 'When industrial equipment and pipelines operate under high or low temperature conditions, drastic temperature changes can easily cause damage. Thermal insulation materials can slow down temperature change rates of equipment and pipelines, reduce thermal stress impact, thereby protecting equipment and extending its service life.'
            }
          ]
        }
      },
      tab2: {
        detailIntro: {
          title: 'Detailed Introduction',
          content: 'Based on different materials, thermal insulation materials can be mainly divided into three categories: organic thermal insulation materials, inorganic thermal insulation materials, and composite thermal insulation materials. Each type has distinct differences in performance, characteristics, and application scenarios.'
        },
        organicMaterials: {
          title: 'I. Organic Thermal Insulation Materials',
          intro: 'Organic thermal insulation materials are made primarily from organic polymer compounds, commonly including polystyrene foam, polyurethane foam, and phenolic foam.',
          items: [
            {
              title: '1. Polystyrene Foam (EPS):',
              content: 'Lightweight with low thermal conductivity, low water absorption, and impact resistance. Widely used in building exterior wall insulation, roof insulation, and packaging. However, poor high-temperature performance.'
            },
            {
              title: '2. Polyurethane Foam (PU):',
              content: 'Divided into rigid and flexible foam. Rigid polyurethane has extremely low thermal conductivity and excellent insulation performance with good adhesion and compressive strength.'
            },
            {
              title: '3. Phenolic Foam (PF):',
              content: 'Excellent high-temperature resistance, flame retardancy, and low smoke toxicity. Does not melt or drip at high temperatures, produces little smoke when burning, and releases minimal toxic gases.'
            }
          ]
        },
        inorganicMaterials: {
          title: 'II. Inorganic Thermal Insulation Materials',
          intro: 'Inorganic thermal insulation materials are made primarily from inorganic minerals, commonly including rock wool, glass wool, expanded perlite, and aerated concrete.',
          items: [
            {
              title: '1. Rock Wool:',
              content: 'Made from basalt and diabase through high-temperature melting and fiberization. Has good thermal insulation, fire resistance, sound insulation, and chemical stability.'
            },
            {
              title: '2. Glass Wool:',
              content: 'Made from quartz sand, feldspar, and soda ash through high-temperature melting and fiberization. Performance similar to rock wool with relatively soft feel.'
            },
            {
              title: '3. Expanded Perlite:',
              content: 'Made from perlite ore through crushing, preheating, and roasting expansion. Lightweight, porous, with small thermal conductivity, non-toxic, odorless, and non-combustible.'
            },
            {
              title: '4. Aerated Concrete:',
              content: 'Made from cement, lime, sand, and fly ash with gas-forming agents. Lightweight, thermal insulating, sound insulating, and fire-resistant with certain strength.'
            }
          ]
        },
        compositeMaterials: {
          title: 'III. Composite Thermal Insulation Materials',
          intro: 'Composite thermal insulation materials are made by combining two or more different types of insulation materials through specific processes, aiming to combine advantages and compensate for individual material shortcomings.',
          items: [
            {
              title: '1. Rock Wool-Polystyrene Composite Board:',
              content: 'Combines rock wool fire performance with polystyrene foam insulation performance, solving polystyrene poor fire resistance while compensating for rock wool insufficient insulation.'
            },
            {
              title: '2. Glass Wool-Polyurethane Composite Pipe:',
              content: 'Uses glass wool as inner core with polyurethane foam as outer layer, combining good sound insulation of glass wool with excellent insulation of polyurethane.'
            },
            {
              title: '3. Inorganic Insulation Mortar-Organic Board Composite System:',
              content: 'Usually uses organic insulation boards as thermal core with inorganic insulation mortar coating outside, providing good fire performance and bonding.'
            }
          ]
        }
      },
      tab3: {
        detailIntro: {
          title: 'Detailed Introduction',
          content: 'When selecting thermal insulation materials, multiple factors need comprehensive consideration to ensure selected materials meet actual usage requirements while achieving energy-saving, safe, and economical purposes.'
        },
        thermalPerformance: {
          title: 'I. Thermal Performance',
          content: 'Thermal performance is the core indicator of insulation materials, usually measured by thermal conductivity coefficient. Lower thermal conductivity means better insulation performance.'
        },
        firePerformance: {
          title: 'II. Fire Performance',
          content: 'Fire performance is crucial, especially in construction and crowded places. Building insulation materials are classified into A-grade (non-combustible), B1-grade (flame-retardant), B2-grade (combustible), and B3-grade (flammable).'
        },
        mechanicalPerformance: {
          title: 'III. Mechanical Performance',
          content: 'Mechanical performance mainly includes compressive strength, tensile strength, and flexural strength. Different usage scenarios have different mechanical performance requirements for insulation materials.'
        },
        weatherResistance: {
          title: 'IV. Weather Resistance and Durability',
          content: 'Insulation materials are affected by external environmental factors during use, such as temperature changes, humidity changes, UV radiation, and rain erosion, requiring good weather resistance and durability.'
        },
        environmentalPerformance: {
          title: 'V. Environmental Performance',
          content: 'With increasing environmental awareness, environmental performance of insulation materials receives more attention. Non-toxic, odorless, and non-radioactive materials should be selected.'
        },
        economicPerformance: {
          title: 'VI. Economic Performance',
          content: 'Under the premise of meeting above performance requirements, economic performance of insulation materials should be considered, including material price, transportation costs, and construction costs.'
        }
      },
      tab4: {
        detailIntro: {
          title: 'Detailed Introduction',
          content: 'With increasing energy crisis and growing environmental awareness, the thermal insulation materials industry continues to develop and innovate, showing several main development trends.'
        },
        highEfficiencyEnergyConservation: {
          title: 'I. High-Efficiency Energy Conservation',
          content: 'Future insulation materials will focus more on improving thermal insulation performance, continuously reducing thermal conductivity to achieve higher energy-saving goals.'
        },
        greenEnvironmentalProtection: {
          title: 'II. Green Environmental Protection',
          content: 'Green environmental protection will become a core trend in insulation material development, focusing on production process environmental protection and material usage safety.'
        },
        multiFunctionalization: {
          title: 'III. Multi-Functionalization',
          content: 'To meet diverse needs of different usage scenarios, insulation materials will develop toward multi-functionality, integrating fire protection, waterproofing, sound insulation, antibacterial, and self-cleaning functions.'
        },
        lightweightThinning: {
          title: 'IV. Lightweight and Thinning',
          content: 'While ensuring thermal insulation and mechanical performance, materials will develop toward lightweight and thinning to reduce structural loads and increase building space.'
        },
        intelligentization: {
          title: 'V. Intelligentization',
          content: 'With smart building and smart city development, insulation materials will gradually develop toward intelligentization, automatically adjusting performance based on environmental changes.'
        }
      }
    }
  },

  // Contact Us
  contactUs: {
    bannerTitle: 'Contact Us',
    title: 'Contact Us',
    zhongshanHQ: 'Zhongshan Headquarters',
    shanghaiHQ: 'Shanghai Headquarters',
    phone: 'Tel',
    email: 'Email',
    address: 'Address',
    zhongshanPhone: '0760-88166996',
    zhongshanEmail: 'info-am@melonbean.com',
    zhongshanAddress: 'No.5 Dongli South Road, Torch Development Zone, Zhongshan, Guangdong',
    shanghaiPhone: '18913853555',
    shanghaiEmail: 'info-am@melonbean.com',
    shanghaiAddress: 'Room 804, No.2369 Rongle East Road, Songjiang District, Shanghai',
    recruit: 'Recruitment',
    urgent: 'Urgent',
    publishedAt: 'Posted: ',
    resumeEmail: 'Send your resume to: info.asia@melonbean.com (note: website recruitment)',
    breadcrumbContact: 'Contact Us',
    breadcrumbRecruit: 'Recruitment',
    job1: {
      urgent: true,
      name: 'General Worker',
      tags: ['Shanghai', '6+ months exp.', 'Bachelor', 'Age 18-55'],
      date: '2025-09-20',
      requirements: 'Job Requirements:',
      resume: 'Resume Submission:',
      resumeContent: 'Send your resume to: info.asia@melonbean.com (note: website recruitment)',
      sections: [
        {
          title: 'I. Basic Requirements',
          content: 'Age 18-55, male or female, in good health, no infectious diseases, heart disease, hypertension or other serious illnesses affecting work. Must hold a valid ID, have no criminal record, be of good character and have no bad habits. Must have basic communication skills, be able to follow work instructions and comply with workshop management and company regulations.',
        },
        {
          title: 'II. Job Competency Requirements',
          content: 'No prior experience required — free pre-job training is provided. Must be able to quickly learn basic operational procedures. Good hands-on skills required; must be able to use simple tools (e.g. screwdrivers, wrenches). Must have a basic sense of responsibility, pay attention to quality, and complete assigned tasks on time. Must have a team spirit and be able to cooperate on assembly line or group tasks without causing production delays.',
        },
        {
          title: 'III. Work Discipline Requirements',
          content: 'No unauthorized absences, tardiness or early departures. Must accept company scheduling arrangements (e.g. single days off, shift rotations). Must strictly follow attendance rules and safety regulations, wear required PPE (e.g. hard hat, gloves, mask), and not operate equipment improperly. Must keep the work area tidy and take care of equipment. Must stay focused on work tasks during working hours.',
        },
        {
          title: 'IV. Preferred Candidates',
          content: 'Candidates with experience in factory general work or assembly line operations are preferred. Those who can commit long-term (6+ months) and accept job rotation are preferred. Candidates who are diligent, have strong execution and a positive work attitude are preferred.',
        },
      ],
    },
    job2: {
      urgent: true,
      name: 'Core Worker / Key Technical Operator',
      tags: ['Shanghai', 'Male/Female', '3+ years exp.', 'Bachelor or above'],
      date: '2025-09-20',
      sections: [
        {
          title: 'I. Job Responsibilities:',
          items: [
            'Responsible for daily operation, process execution and quality control of key production processes',
            'Proficiently operate core equipment to ensure stable operation and safe production',
            'Complete production tasks according to process documents and work instructions',
            'Participate in production anomaly analysis and propose improvement suggestions',
            'Assist in training new employees and serve as a technical backbone',
            'Cooperate with process, quality, and equipment departments on improvements and audits',
            'Strictly implement safety, 5S and company management systems',
          ],
        },
        {
          title: 'II. Qualifications:',
          groups: [
            { label: 'Education:', lines: ['Bachelor degree or above', 'Mechanical manufacturing, mechatronics, automation, materials or industrial engineering preferred'] },
            { label: 'Experience:', lines: ['3+ years in manufacturing frontline or technical roles', 'Experience with key processes and core equipment preferred', 'Experience as team leader, technical backbone or mentor preferred'] },
            { label: 'Skills:', lines: ['Familiar with production processes, strong hands-on ability', 'Able to independently handle common production anomalies', 'Strong sense of responsibility, high execution, able to work shifts or overtime', 'Good communication and teamwork skills'] },
          ],
        },
        {
          title: 'III. Bonus Qualifications:',
          items: [
            'Familiar with automated production lines or CNC equipment',
            'Participated in process improvement or cost-reduction projects',
            'Basic equipment maintenance or inspection capability',
            'Experience with Lean Production, TPM, or Six Sigma',
          ],
        },
        {
          title: 'IV. Career Development:',
          items: [
            'Core Worker → Technical Backbone → Team Leader / Process Technician',
            'Outstanding performers may develop into production or technical management roles',
          ],
        },
        {
          title: 'V. Compensation & Benefits:',
          items: [
            'Salary: negotiable (competency-based)',
            'Social insurance & commercial insurance',
            'Year-end bonus, skill allowance, overtime pay',
            'Accommodation / meals / holiday benefits provided',
          ],
        },
      ],
      resume: 'Resume Submission:',
      resumeContent: 'Send your resume to: info.asia@melonbean.com (note: website recruitment)',
    },
    job3: {
      urgent: true,
      name: 'Sales Representative / Regional Sales Executive',
      tags: ['Shanghai', 'Male/Female', '3+ years exp.', 'Bachelor or above'],
      date: '2025-09-20',
      sections: [
        {
          title: 'I. Job Responsibilities:',
          items: [
            'Develop markets and clients in designated regions or industries, build stable customer partnerships and achieve annual sales targets',
            'Maintain existing customer relationships, conduct regular visits and needs research, respond promptly to customer requests',
            'Match customer needs precisely, develop personalized sales plans, complete the full sales cycle including quotation, negotiation and contracting',
            'Track order fulfilment progress, coordinate internal departments to ensure smooth delivery',
            'Collect market intelligence and competitor information, provide analysis reports to support product and marketing strategy',
            'Actively participate in sales promotions, trade shows and industry events to expand brand influence',
            'Strictly follow sales management policies, maintain accurate sales records and ensure timely payment collection',
          ],
        },
        {
          title: 'II. Qualifications:',
          groups: [
            { label: 'Education:', lines: ['Bachelor degree or above', 'Materials, chemical engineering, electronics or related fields preferred'] },
            { label: 'Experience:', lines: ['3+ years of B2B/B2C sales experience; electronics or materials industry experience preferred', 'Proven track record of developing markets and achieving high-performance targets preferred', 'Experience in sales team collaboration, account management or mentoring preferred'] },
            { label: 'Skills:', lines: ['Familiar with the full sales process; sharp market insight and ability to uncover customer needs', 'Excellent communication, negotiation and problem-solving skills', 'Goal-oriented, resilient, strong execution; able to travel and work overtime as needed', 'Good professional ethics, integrity and teamwork spirit'] },
          ],
        },
        {
          title: 'III. Bonus Qualifications:',
          items: [
            'Industry product knowledge; technical or solution-based selling experience',
            'Experience developing and managing key accounts, building long-term partnerships',
            'Basic market analysis, sales strategy development and execution skills',
            'Valid driving license with experience in cross-regional market development',
          ],
        },
        {
          title: 'IV. Career Development:',
          items: [
            'Core path: Sales Representative → Senior Sales → Sales Supervisor / Regional Sales Manager',
            'Outstanding performers may move into sales management, marketing planning or customer operations',
          ],
        },
        {
          title: 'V. Compensation & Benefits:',
          items: [
            'Salary: negotiable (base + high commission + performance bonus, uncapped)',
            'Social insurance & commercial insurance',
            'Year-end bonus, travel allowance, communication allowance, business trip allowance, holiday gifts',
            'Meals/meal allowance, team building, annual health check, paid annual leave',
          ],
        },
      ],
      resume: 'Resume Submission:',
      resumeContent: 'Send your resume to: info.asia@melonbean.com (note: website recruitment)',
    },
    job4: {
      urgent: true,
      name: 'Factory IT Operations Engineer',
      tags: ['Shanghai', 'Male/Female', '3+ years exp.', 'Bachelor or above'],
      date: '2025-09-20',
      sections: [
        {
          title: 'I. Job Responsibilities:',
          items: [
            'Responsible for daily O&M of factory servers, network devices, industrial control terminals and production line IT systems (MES/ERP/SCADA), ensuring 7x24 stable operation',
            'Develop and execute IT device inspection, data backup, vulnerability patching and industrial control system maintenance plans',
            'Rapidly respond to workshop IT faults, device alerts and staff IT requests; complete fault diagnosis and resolution; produce fault analysis reports',
            'Participate in IT infrastructure expansion and industrial network architecture optimization; support MES/SCADA deployment and commissioning',
            'Drive standardization of IT O&M processes; develop emergency plans for industrial control systems',
            'Support R&D and process departments in new production line deployment and system version iterations',
            'Manage full lifecycle of factory IT assets; implement information security and industrial control security policies',
          ],
        },
        {
          title: 'II. Qualifications:',
          groups: [
            { label: 'Education:', lines: ['Bachelor degree or above', 'Computer science, network engineering, information security, industrial automation or related fields preferred'] },
            { label: 'Experience:', lines: ['3+ years of factory IT O&M or industrial control O&M experience; manufacturing IT experience preferred', 'Experience with factory servers, industrial networks, MES/ERP/SCADA systems preferred', 'Experience in production line IT fault emergency handling and cross-department collaboration preferred'] },
            { label: 'Skills:', lines: ['Proficient in Windows/Linux O&M, enterprise network device configuration, and at least one industrial control system', 'Solid knowledge of computer networking and industrial control security; ability to independently diagnose factory IT faults', 'Strong service mindset and sense of responsibility; able to work shifts and handle emergency faults', 'Good cross-department communication and teamwork skills'] },
          ],
        },
        {
          title: 'III. Bonus Qualifications:',
          items: [
            'Familiar with PLC basics, industrial Ethernet configuration; able to assist in debugging industrial control and IT interfaces',
            'Experience in IT O&M process optimization, industrial control security hardening, or backup solution upgrades',
            'Familiar with virtualization, containerization or cloud platform O&M; experience in factory IT asset digitization',
            'Holds Alibaba Cloud/Huawei Cloud certification, industrial control security certification, or equivalent',
          ],
        },
        {
          title: 'IV. Career Development:',
          items: [
            'Technical path: Factory IT Engineer → Senior O&M Engineer → Industrial Control Expert / Factory IT Architect',
            'Management path: outstanding performers may develop into Factory IT Supervisor, O&M Manager, or Smart Manufacturing IT Lead',
          ],
        },
        {
          title: 'V. Compensation & Benefits:',
          items: [
            'Salary: negotiable (fixed salary + performance bonus + production assurance bonus)',
            'Social insurance & commercial insurance',
            'Year-end bonus, O&M allowance, shift/overtime pay, transport & communication allowance, holiday gifts',
            'Factory accommodation / meals, team building, annual health check, paid annual leave',
          ],
        },
      ],
      resume: 'Resume Submission:',
      resumeContent: 'Send your resume to: info.asia@melonbean.com (note: website recruitment)',
    },
    job5: {
      urgent: true,
      name: 'Sales Executive',
      tags: ['Shanghai', 'Age 20-40', 'Male/Female', 'High school or above'],
      date: '2025-09-20',
      sections: [
        {
          title: 'Job Requirements:',
          groups: [
            {
              label: 'I. Basic Requirements',
              lines: ['Age 20-40, male or female, high school or above, good health, no bad habits, able to travel and visit clients. Must hold a valid ID, have no criminal record, good character, and maintain confidentiality of company business information. Must have clear communication and logical thinking skills. Must accept company culture, follow management arrangements, comply with attendance and sales policies, and commit long-term.'],
            },
            {
              label: 'II. Core Job Requirements',
              lines: ['Industry experience: 1+ years in electronics sales; familiar with product features and sales models.', 'Product knowledge: able to quickly grasp core product specs and match customer needs with appropriate solutions.', 'Client development: able to develop new clients through calls, visits and trade shows.', 'Sales execution: independently handle the full sales cycle including quotation, negotiation, order tracking and after-sales service to achieve individual sales targets.', 'Tools: proficient in Office software (Excel, Word, PPT) and WeChat/WeCom; able to maintain accurate customer records and sales data.'],
            },
            {
              label: 'III. Work Attitude & Quality',
              lines: ['Resilient; able to handle performance pressure and maintain a positive attitude when facing rejection.', 'Responsible; responsive to customer needs and order delivery; maintains good client relationships.', 'Team-oriented; actively shares industry information and sales tips to help the team.', 'Continuous learner; stays up to date with industry trends, market dynamics and competitor information.'],
            },
            {
              label: 'IV. Preferred Candidates',
              lines: ['Sales experience in electronics components, consumer electronics, smart home or industrial equipment preferred.', 'Existing local client resources (dealers, factory procurement) preferred.', 'Electronics technical background preferred.', 'Outgoing personality, strong interpersonal skills, good at business negotiation and client management preferred.'],
            },
          ],
        },
      ],
      resume: 'Resume Submission:',
      resumeContent: 'Send your resume to: info.asia@melonbean.com (note: website recruitment)',
    },
    job6: {
      urgent: true,
      name: 'Factory IT Operations Engineer',
      tags: ['Shanghai', 'Age 22-38', 'Male/Female', 'Bachelor or above'],
      date: '2025-09-20',
      sections: [
        {
          title: 'Job Requirements:',
          groups: [
            {
              label: 'I. Basic Requirements',
              lines: ['Age 22-38, bachelor degree or above; computer science, network engineering, automation or related fields preferred. Valid ID, no criminal record, good character, strict confidentiality of factory production data. Strong logical thinking, problem analysis and emergency response skills. Good cross-department communication skills; able to work with production, equipment management and administration departments. Able to work shifts, on-call duties and overtime; resilient under pressure.'],
            },
            {
              label: 'II. Core Job Requirements',
              lines: ['Factory network O&M: proficient in TCP/IP; independently build and maintain factory LANs and workshop IoT networks; proficient in configuring routers, switches and firewalls; quickly diagnose network anomalies to ensure stable production data transmission.', 'Industrial equipment O&M: familiar with factory industrial control equipment (PLC, industrial PCs, SCADA, MES) basic operations; assist with device networking, data collection and system integration.', 'Server & system O&M: proficient in Linux (CentOS, Ubuntu) and Windows Server; handle server/database installation, backup, optimization and fault resolution to keep core business systems running stably.', 'Terminal device O&M: quickly diagnose and resolve faults on PCs, production terminals, printers and scanners to ensure normal office and production operations.', 'Automation & monitoring: basic Shell or Python scripting ability; familiar with Zabbix or similar monitoring tools; build factory IT monitoring systems for real-time alerts.', 'Security management: knowledge of industrial network security; assist in defining factory IT security policies to prevent virus attacks and data leaks.'],
            },
            {
              label: 'III. Work Experience',
              lines: ['1-3+ years of factory or manufacturing IT O&M experience; familiarity with factory production processes and industrial IT architecture preferred.', 'Experience deploying, maintaining or integrating factory MES, ERP or WMS systems preferred.', 'Experience handling production equipment networking faults, system downtime or data loss emergencies preferred.'],
            },
            {
              label: 'IV. Work Attitude & Quality',
              lines: ['Highly responsible; accountable for factory production system stability and data security; proactively identifies and prevents potential technical risks.', 'Continuous learner; keeps up with industrial internet and smart manufacturing technologies.', 'Meticulous; strictly follows procedures for system configuration changes, device commissioning and software upgrades to avoid human errors.', 'Strong service mindset; responds quickly to IT requests from workshops and departments; provides patient technical guidance.'],
            },
            {
              label: 'V. Preferred Candidates',
              lines: ['Holds certifications such as CCNA/CCNP, industrial internet certification or Alibaba Cloud ACP preferred.', 'Familiar with Docker, Kubernetes or IoT platform O&M preferred.', 'Experience in large manufacturing factory O&M teams or managing entire production line IT systems preferred.', 'Electrical automation background; able to assist with industrial equipment and IT system integration preferred.'],
            },
          ],
        },
      ],
      resume: 'Resume Submission:',
      resumeContent: 'Send your resume to: info.asia@melonbean.com (note: website recruitment)',
    },
    jobs: [
      {
        urgent: true,
        jobName: 'General Worker',
        requireList: ['Shanghai', '6+ months exp.', 'Bachelor'],
        createDate: '2025-09-20',
      },
      {
        urgent: true,
        jobName: 'Core Worker / Key Technician',
        requireList: ['Shanghai', '3+ years exp.', 'Bachelor or above'],
        createDate: '2025-09-20',
      },
      {
        urgent: true,
        jobName: 'Sales Representative',
        requireList: ['Shanghai', '3+ years exp.', 'Bachelor or above'],
        createDate: '2025-09-20',
      },
      {
        urgent: true,
        jobName: 'Factory IT Operations Engineer',
        requireList: ['Shanghai', '3+ years exp.', 'Bachelor or above'],
        createDate: '2025-09-20',
      },
      {
        urgent: true,
        jobName: 'Sales Executive',
        requireList: ['Shanghai', 'Age 20-40', 'High school or above'],
        createDate: '2025-09-20',
      },
      {
        urgent: true,
        jobName: 'Factory IT Operations Engineer',
        requireList: ['Shanghai', 'Age 22-38', 'Bachelor or above'],
        createDate: '2025-09-20',
      },
    ],
  },
}
